module.exports = __webpack_public_path__ + "static/media/BuckN'Flax Cookies 200g.bbbc856b.jpg";